import { BLOG_CATEGORY, buildBlogFilePath, type BlogMetaData } from '../types';

export const restless3YearOld: BlogMetaData = {
  title: '3歳児が落ち着きがない理由｜発達の範囲内？場面別の見方と関わり方',
  description:
    '3歳児が落ち着きがないのは普通？2歳児から続く動きの多さの背景を、家と園・自由活動と集団活動などの場面別に整理。睡眠・空腹・見通しなど家庭でできる調整と、相談を考える目安をモンテッソーリの視点で解説します。',
  thumbnailUrl: '/img/blog-restless-3-year-old.webp',
  filePath: buildBlogFilePath('restless-3-year-old'),
  category: BLOG_CATEGORY.PARENTING,
};
